export const CLIENT_USER_TYPE = 5;

export const CLIENT_USER_STATUS = Object.freeze({
  active: 1,
  pending: 8,
});

export const CLIENT_PORTAL_REFRESH_STORAGE_KEY =
  "kalopsia.accounts.client.refresh";

export const CLIENT_PORTAL_PATHS = Object.freeze({
  login: "/login",
  register: "/register",
  account: "/account",
});

export const REQUEST_CONTEXT = Object.freeze({
  public: "public",
  guest: "guest",
  client: "client",
});

export const AUTH_STATUS = Object.freeze({
  anonymous: "anonymous",
  restoring: "restoring",
  authenticating: "authenticating",
  authenticated: "authenticated",
  expired: "expired",
});

export const CLAIM_STATUS = Object.freeze({
  registered: 0,
  claimed: 1,
  consumed: 2,
  missed: 3,
  pending: 4,
});

export const CLAIM_STATUS_LABELS = Object.freeze({
  [CLAIM_STATUS.registered]: "Registered",
  [CLAIM_STATUS.claimed]: "Claimed",
  [CLAIM_STATUS.consumed]: "Consumed",
  [CLAIM_STATUS.missed]: "Missed",
  [CLAIM_STATUS.pending]: "Pending",
});

export const CLIENT_PORTAL_ERROR = Object.freeze({
  invalidLogin: "invalid_login",
  sessionExpired: "session_expired",
  accountUnavailable: "account_unavailable",
  temporarilyUnavailable: "temporarily_unavailable",
  promotionAlreadyClaimed: "promotion_already_claimed",
  promotionUnavailable: "promotion_unavailable",
  checkoutValidation: "checkout_validation_error",
  paymentPending: "payment_pending",
  paymentFailed: "payment_failed",
  unknown: "unknown",
});
